import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import cpfValidate from '@vr/devkit/validators/cpfValidate';
import { ContainerButton, Title, Description, Actions } from './common';
import { Button, MaskField } from '../../elements';
import getErrorMsg from '../../helpers/errorMessages';

const ContainerActions = styled.div`
  margin-top: 23px;
`;

const StyledDescription = styled(Description)`
  margin-bottom: 24px;
`;

export default function ForgotEmailForm({ onSubmit }) {
  const { handleSubmit, errors, formState, trigger, ...formControl } = useForm({
    mode: 'onChange',
  });
  const history = useHistory();

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Title color="white">Esqueci meu e-mail</Title>
      <StyledDescription fontSize="15" color="white">
        Informe os dados abaixo para receber o e-mail de acesso.
      </StyledDescription>
      <MaskField
        fullWidth
        ariaLabel="Informe seu CPF"
        label="Informe seu CPF"
        name="cpf"
        mask="999.999.999-99"
        type="tel"
        rules={{
          required: true,
          minLength: 14,
          validate: val => {
            return cpfValidate(val);
          },
        }}
        formControl={formControl}
        error={!!errors.cpf}
        caption={getErrorMsg(errors, 'cpf')}
        executeActionOnBlur={() => trigger('cpf')}
      />

      <ContainerActions>
        <Actions>
          <Button
            ariaLabel="Botão para solicitar lembrete"
            label="Solicitar lembrete"
            type="submit"
            variant="contained"
            disabled={!formState.isValid}
          />
          <ContainerButton>
            <Button
              label="Cancelar"
              onClick={() => history.push('/login')}
              variant="transparent"
            />
          </ContainerButton>
        </Actions>
      </ContainerActions>
    </form>
  );
}

ForgotEmailForm.propTypes = {
  onSubmit: PropTypes.func,
};
